"use client";

import React from "react";
import {PageCompetitionBookTySchema} from "@/sanity/pages/PageCompetitionBookTyTemplate";

import Image from "next/image";
import DividerGreenLine from "@/components/global/ui/DividerGreenLine";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";

export default function StepsSection({
  data,
  className
}: {
  data: PageCompetitionBookTySchema;
  className?: string;
}) {
  return (
    <section className={cn(
      "relative overflow-clip pb-[8rem] lg:pb-[15rem]",
      className
    )}>
      <div className="container flex flex-col items-center">
        {data?.stepsText && (
          <div className="richtext prose-h2:text-white prose-h2:font-ivy prose-h2:italic prose-h2:pb-[4rem] lg:prose-h2:pb-[5rem]">
            <PortableText
              value={data.stepsText}
              components={richTextComponent}
            />
          </div>
        )}

        {data?.stepsItems && (
          <div className="w-[min(145.75rem,100%)] flex flex-col gap-[8rem] lg:gap-[15rem]">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-[3rem]">
              {data?.stepsItems.map((step, index) => (
                <div
                  key={index}
                  className="bg-[#112628] p-[3rem] flex lg:flex-col items-start gap-[4rem]"
                >
                  <p className="mb-0 leading-none text-[#D9F9B9]/50 font-ivy text-[9rem] italic flex-shrink-0">{index + 1}</p>

                  <div className="flex flex-col">
                    <div className="flex items-center gap-[2rem] mb-[1rem]">
                      {step?.icon && (
                        <Image
                          className="!w-[2.5rem] flex-shrink-0"
                          src={step.icon}
                          alt=""
                        />
                      )}

                      <h3 className="font-geist !text-white !text-[2.25rem] !font-normal uppercase !mb-0 leading-[1.3]">{step.title}</h3>
                    </div>

                    {step?.text && (
                      <div className="richtext richtext-start prose-p:font-light prose-p:text-white/60 prose-strong:font-normal prose-strong:text-white">
                        <PortableText
                          value={step.text}
                          components={richTextComponent}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <DividerGreenLine
              className="w-full"
            />
          </div>
        )}
      </div>
    </section>
  );
}
